import React from 'react';
import { FiUsers } from 'react-icons/fi';
import ServiceTemplate from './ServiceTemplate';

export default function CRMOperationsService() {
  return (
    <ServiceTemplate
      slug="crm-operations"
      color="#d97706"
      icon={<FiUsers size={40} />}
      title="CRM & Operations Consulting"
      tagline="Optimize your customer operations with AI-enhanced CRM systems and intelligent workflows."
      heroDescription="Your CRM should be your competitive advantage, not a data graveyard. We implement, customize, and supercharge CRM platforms with AI — from automated lead scoring to intelligent routing to predictive churn analysis. More revenue, less manual work."
      features={[
        { title: 'CRM Implementation & Migration', description: 'Full deployment or migration across Salesforce, HubSpot, Pipedrive, or custom CRMs. Data mapping, workflow configuration, and team training.' },
        { title: 'Sales Pipeline Automation', description: 'Automate deal progression, follow-up sequences, task assignment, and reporting. Eliminate the manual work that slows your sales team down.' },
        { title: 'AI-Powered Lead Scoring', description: 'ML models that predict conversion probability based on behavioral signals, firmographic data, and engagement patterns. Prioritize the right leads.' },
        { title: 'Customer Data Platform', description: 'Unify customer data from every touchpoint — web, email, support, product usage — into a single 360° view. Power personalization at scale.' },
        { title: 'Revenue Operations', description: 'Align sales, marketing, and CS around shared metrics. Build attribution models, forecasting dashboards, and automated reporting.' },
        { title: 'Support & Success Automation', description: 'AI-powered ticket routing, sentiment analysis, churn prediction, and automated playbooks for customer success teams.' },
      ]}
      useCases={[
        { title: 'CRM Overhaul for SaaS Company', description: 'Migrated from legacy Salesforce to a modern HubSpot setup with custom AI lead scoring.', result: '40% increase in MQL-to-SQL conversion rate' },
        { title: 'Automated Data Entry Elimination', description: 'Built LLM-powered extraction from emails and calls to auto-populate CRM fields.', result: '89% reduction in manual data entry, 97.1% accuracy' },
        { title: 'Churn Prediction System', description: 'Deployed a churn prediction model for a B2B SaaS with 2,000+ accounts.', result: '30% reduction in annual churn through proactive outreach' },
      ]}
      techStack={[
        'Salesforce', 'HubSpot', 'Pipedrive', 'Zoho CRM',
        'Segment', 'Rudderstack', 'Amplitude', 'Mixpanel',
        'Python', 'Node.js', 'PostgreSQL', 'Redis',
        'OpenAI GPT-4', 'LangChain', 'Zapier', 'Make',
        'Looker', 'Tableau', 'dbt', 'Snowflake',
      ]}
    />
  );
}
